
import React, { useState } from "react";
import {
    Box,
    Flex,
    Heading,
    useColorModeValue,
    Text,
    Img,
} from "@chakra-ui/react";
import CenteredAuth from "layouts/auth/types/Centered";
import { useAuth } from "contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import CInput from "components/CInput";
import CButton from "components/CButton";

function ForgotPassword() {
    const { forgotPassword } = useAuth();

    const [validated, setValidated] = useState(false);
    const [credential, setCredential] = useState({
        email: "",
    });

    const navigate = useNavigate();

    const textColor = useColorModeValue("navy.700", "white");
    const textColorSecondary = "gray.400";

    const handleSubmit = async (e) => {
        e.preventDefault();
        setValidated(true);

        if (!credential.email) return;

        try {
            const data = await forgotPassword(credential.email);
            if (!data.error) {
                navigate('/')
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <CenteredAuth
            image={"linear-gradient(135deg, #868CFF 0%, #4318FF 100%)"}
            cardTop={{ base: "140px", md: "24vh" }}
            cardBottom={{ base: "50px", lg: "auto" }}>
            <Flex
                maxW={{ base: '100%', md: 'max-content' }}
                w="100%"
                mx={{ base: 'auto', lg: '0px' }}
                me="auto"
                justifyContent="center"
                px={{ base: '20px', md: '0px' }}
                flexDirection="column"
            >
                <Flex
                    flexDirection="column"
                    justifyContent="center"
                    w={{ base: '100%', md: '420px' }}
                >
                    <Img
                        src='/logo8.png'
                        h='auto'
                        w="215px"
                        px='20px'
                        mb="52px"
                        alignSelf="center"
                    />
                </Flex>
                <Box me='auto' mb='34px'>
                    <Heading
                        color={textColor}
                        fontSize={{ base: "3xl", md: "36px" }}
                        mb='16px'>
                        Forgot your password?
                    </Heading>
                    <Text
                        color={textColorSecondary}
                        fontSize='md'
                        w={{ base: "100%", lg: "456px" }}
                        maxW='100%'>
                        No problem. Just let us know your email address and we'll email you
                        a password reset link that will allow you to choose a new one.
                    </Text>
                </Box>
                <Flex
                    zIndex="2"
                    direction="column"
                    w="100%"
                    background="transparent"
                    borderRadius="15px"
                    mx={{ base: 'auto', lg: 'unset' }}
                    me="auto"
                    mb={{ base: '20px', md: 'auto' }}
                >
                    <form onSubmit={handleSubmit}>
                        <CInput
                            label="Email"
                            type="text"
                            value={credential.email}
                            onChange={(value) => setCredential({ ...credential, email: value })}
                            required={true}
                            validated={validated}
                            errorMessage="Email is required."
                            placeholder="mail@sample.com"
                        />
                        <CButton
                            type="submit"
                            mb='24px'
                        >
                            Email password reset link
                        </CButton>
                    </form>
                </Flex>
            </Flex>
        </CenteredAuth>
    );
}

export default ForgotPassword;
